import React from "react";
import { StyledEditableInput } from "../../../../components/inline-edit/styled";
import { useAnnouncementsStore } from "../../../../stores/use-announcements-store";

function EditableLine({ value, propKey, isEditable }) {
  const { updateAnnouncement } = useAnnouncementsStore((state) => ({
    updateAnnouncement: state.updateAnnouncement,
  }));

  return (
    <>
      {isEditable ? (
        <StyledEditableInput
          size={value.length}
          value={value}
          onChange={(e) =>
            updateAnnouncement({ key: propKey, value: e.target.value })
          }
        />
      ) : (
        value
      )}
    </>
  );
}

export default EditableLine;
